<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { cargarExSuscriptores } from "@/services/exSuscriptores";
import { descargarCsv } from "@/services/csv";

/**
 * Ex-suscriptores: quienes tuvieron Recnet Plus y cancelaron, con su fecha de
 * cancelación. Es el submenú "Sin membresía" de Suscriptores.
 */
export default {
  page: {
    title: "Sin membresía",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      exSuscriptores: [],
      cargando: true,
      error: null,
      busqueda: "",
      currentPage: 1,
      perPage: 15,
      campos: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "phone", label: "Teléfono" },
        { key: "creadoEnFormatted", label: "Registro" },
        { key: "cancelacionTexto", label: "Canceló el", sortable: true },
      ],
    };
  },
  computed: {
    filas() {
      const q = this.busqueda.trim().toLowerCase();
      if (!q) return this.exSuscriptores;
      return this.exSuscriptores.filter((e) =>
        [e.name, e.email, e.phone].filter(Boolean).some((v) => String(v).toLowerCase().includes(q))
      );
    },
  },
  watch: {
    filas() {
      this.currentPage = 1;
    },
  },
  methods: {
    exportar() {
      descargarCsv(
        "sin_membresia",
        [
          { key: "name", label: "Nombre" },
          { key: "email", label: "Correo" },
          { key: "phone", label: "Teléfono" },
          { key: "creadoEnFormatted", label: "Fecha de registro" },
          { key: "cancelacionTexto", label: "Fecha de cancelación" },
        ],
        this.filas
      );
    },
    async cargar() {
      this.cargando = true;
      this.error = null;
      try {
        this.exSuscriptores = await cargarExSuscriptores();
      } catch (err) {
        console.error("[sin-membresia] error al cargar:", err);
        this.error = "No pudimos cargar los ex-suscriptores. Inténtalo de nuevo.";
      } finally {
        this.cargando = false;
      }
    },
  },
  mounted() {
    this.cargar();
  },
};
</script>

<template>
  <Layout>
    <div class="mb-4">
      <img :src="require('@/assets/images/recnet-header.png')" alt="Recnet"
        class="img-fluid w-100 rounded shadow-sm"
        style="max-height: 260px; object-fit: cover; object-position: center;" />
    </div>

    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <div>
            <h4 class="card-title mb-1">Sin membresía</h4>
            <p class="text-muted mb-0">Quienes tuvieron Recnet Plus y cancelaron.</p>
          </div>
          <div class="d-flex align-items-center">
            <b-button size="sm" variant="outline-secondary" class="mr-2" :disabled="cargando" @click="cargar">
              <i class="mdi mdi-refresh"></i>
            </b-button>
            <b-button size="sm" variant="info" :disabled="filas.length === 0" @click="exportar">
              <i class="mdi mdi-download"></i> CSV
            </b-button>
          </div>
        </div>

        <b-alert :show="!!error" variant="warning">{{ error }}</b-alert>

        <b-form-input v-model="busqueda" type="search" placeholder="Buscar por nombre, correo o teléfono…"
          class="mb-3" />

        <p v-if="cargando" class="text-muted">Consultando Stripe…</p>

        <p v-else-if="exSuscriptores.length === 0" class="text-muted">
          Nadie ha cancelado su membresía todavía.
        </p>

        <template v-else>
          <b-table responsive hover :items="filas" :fields="campos" :per-page="perPage"
            :current-page="currentPage">
            <template #cell(name)="{ item }">
              {{ item.name }}<br />
              <small class="text-muted">{{ item.email }}</small>
            </template>
            <template #cell(cancelacionTexto)="{ item }">
              <b-badge variant="danger">{{ item.cancelacionTexto }}</b-badge>
            </template>
          </b-table>

          <b-pagination v-model="currentPage" :total-rows="filas.length" :per-page="perPage" align="right"
            size="sm" class="mt-3" first-number last-number />
        </template>
      </div>
    </div>
  </Layout>
</template>
